import { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import { LanguageProvider } from './contextApi/LanguageContext';
import MainPage from './pages/MainPage';
import { liftBootSheet } from './boot';

// Only the main page ships in the entry chunk; the rest load on demand.
const loadMentoringPage = () => import('./pages/MentoringPage');
const MentoringPage = lazy(loadMentoringPage);
const OgImagePage = lazy(() => import('./pages/OgImagePage'));

// The CV is a static page served from public/cv, outside of the SPA — force a full page load.
const CvRedirect = () => {
	window.location.replace('/cv');
	return null;
};

const rootElement = document.getElementById('root');

function render(root: HTMLElement) {
	ReactDOM.createRoot(root).render(
		<Router>
			<LanguageProvider>
				<Suspense fallback={null}>
					<Routes>
						<Route path='/' element={<MainPage />} />
						<Route path='/pl' element={<MainPage />} />
						<Route path='/en' element={<MainPage />} />
						<Route path='/mentoring' element={<MentoringPage />} />
						<Route path='/pl/mentoring' element={<MentoringPage />} />
						<Route path='/en/mentoring' element={<MentoringPage />} />
						<Route path='/cv/*' element={<CvRedirect />} />
						{import.meta.env.DEV && <Route path='/og-image' element={<OgImagePage />} />}
						<Route path='*' element={<Navigate to='/' replace />} />
					</Routes>
				</Suspense>
			</LanguageProvider>
		</Router>
	);
	liftBootSheet();
}

if (rootElement) {
	// On a mentoring URL, fetch its chunk first so the boot sheet never lifts onto an empty page.
	const ready = /^\/(?:pl\/|en\/)?mentoring\/?$/.test(window.location.pathname) ? loadMentoringPage().catch(() => undefined) : Promise.resolve();
	ready.then(() => render(rootElement));
} else {
	console.error("Couldn't find root element");
}
